/* Animated "Naïa is thinking" indicator shown in an assistant bubble while the
   model is loading, before the first token streams in. Replaces the static "…".
   Self-contained (its own assistant-styled bubble) so the three chat screens
   (élève / prof / admin) share one consistent animation. */

function Dot({ delay }: { delay: number }) {
  return (
    <span
      className="w-2 h-2 rounded-full bg-naia-blue inline-block [animation:typing_1.1s_ease-in-out_infinite] motion-reduce:![animation:none] motion-reduce:!opacity-70"
      style={{ animationDelay: `${delay}ms` }}
    />
  );
}

export default function TypingDots({ label = 'Naïa réfléchit' }: { label?: string }) {
  return (
    <div role="status" aria-label={`${label}…`} className="self-start max-w-[85%] bg-naia-info-bg rounded-card px-4 py-[14px] shadow-card inline-flex items-center gap-[6px]">
      <Dot delay={0} />
      <Dot delay={160} />
      <Dot delay={320} />
    </div>
  );
}
